<form [formGroup]="list" [id]="id">
    @for (item of list.controls; let i = $index; track i) {
        <div class="sh-form-row-with-action" style="margin-bottom: 0px">
            <div class="sh-form-row-with-action__inputs">
                @if (getValueControl(i); as control) {
                    <div class="sh-form-row-with-action__inputs__item" [ngClass]="{ 'sh-form-group': control.invalid }">
                        @switch (controlType()) {
                            @case ("number") {
                                <sh-form-number-input
                                    #inputFields
                                    [id]="getValueId(i)"
                                    [control]="control"
                                    [title]="disabledMsg"
                                    [attr.step]="step"
                                    [attr.min]="min"
                                    [attr.max]="max"
                                    [placeholder]="placeholderMsg || null"
                                    (keyup.enter)="addEmptyLine($event)"
                                >
                                </sh-form-number-input>
                            }
                            @case ("date") {
                                <sh-form-date
                                    #inputFields
                                    [id]="getValueId(i)"
                                    [control]="control"
                                    [placeholder]="'form.date.format' | translate"
                                    [invalidDateMsg]="'form.date.invalid-date' | translate"
                                    [title]="disabledMsg"
                                    (keyup.enter)="addEmptyLine($event)"
                                >
                                </sh-form-date>
                            }
                            @case ("edtf") {
                                <sh-form-edtf
                                    #inputFields
                                    [id]="getValueId(i)"
                                    [control]="control"
                                    [title]="disabledMsg"
                                    [typePlaceholderMsg]="'form.edtf.choose-type' | translate"
                                    [formatExamplePrefix]="'form.edtf.example-prefix' | translate"
                                    [invalidFormatMsg]="'form.edtf.invalid-format' | translate"
                                    [unrecognizedFormatMsg]="'form.edtf.unrecognized-format' | translate"
                                    (keyup.enter)="addEmptyLine($event)"
                                >
                                </sh-form-edtf>
                            }
                            @default {
                                <sh-autocomplete [autocompleteFct]="autocompleteFct">
                                    <input
                                        #inputFields
                                        tabindex="0"
                                        type="text"
                                        autocomplete="off"
                                        [formControl]="control"
                                        [id]="getValueId(i)"
                                        [attr.placeholder]="placeholderMsg || null"
                                        class="sh-form-group__input sh-input-field"
                                        [attr.disabled]="disabled ? true : null"
                                        (blur)="sanitizeValue($event, i)"
                                        [title]="disabledMsg"
                                        (keyup.enter)="addEmptyLine($event)"
                                    />
                                </sh-autocomplete>
                            }
                        }
                        <!-- 
                        @if (control.invalid && control.errors?.message) {
                            <p class="sh-form-group -sh-is-invalid sh-form-group__feedback">
                                {{ control.errors?.message | translate }}
                            </p>
                        } -->
                    </div>
                }
            </div>
            @if (actionItems$ | async; as actionItems) {
                <div class="sh-form-row-with-action__actions">
                    @for (actionItem of actionItems[i]; track actionItem) {
                        <sh-action-item class="sh-form-row-with-action__actions__item" [item]="actionItem" [bubbleEvent]="false"></sh-action-item>
                    }
                </div>
            }
        </div>
    }
</form>
@if ((hasDuplicateInput$ | async) && duplicateErrorMsg) {
    <p class="sh-form-group__feedback">{{ duplicateErrorMsg }}</p>
}
@if (isIndeterminate && indeterminateMsg) {
    <p class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
}
